import { useNavigate } from 'react-router-dom';
import styles from '../styles/Login.module.css';

const Login = () => {
  const navigate = useNavigate();
  const handleLogin = () => {
    window.location.href = process.env.REACT_APP_LOGIN_URL;
  };
  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginCard}>
        <h2 className={styles.loginTitle}>Welcome Back!</h2>
        <p className={styles.loginDescription}>
          Please click below to log in to your account.
        </p>
        <button className={styles.loginButton} onClick={handleLogin}>
          Log In
        </button>
      </div>
    </div>
  );
};
export default Login;
